
import React from "react";
import { Input } from "@/components/ui/input";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { BookText, Tag } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { DatePickerField } from "./DatePickerField";

interface EssentialDetailsTabProps {
  form: UseFormReturn<any>;
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
}

export function EssentialDetailsTab({ form, date, setDate }: EssentialDetailsTabProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center">
              <BookText className="w-4 h-4 mr-2" />
              Sermon Title *
            </FormLabel>
            <FormControl>
              <Input 
                placeholder="Enter sermon title" 
                {...field} 
                className="focus:ring-2 focus:ring-offset-1 focus:ring-primary-500"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="scripture_reference"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center">
              <Tag className="w-4 h-4 mr-2" />
              Scripture Reference
            </FormLabel>
            <FormControl>
              <Input
                placeholder="e.g. John 3:16 or Matthew 5:3-12"
                {...field}
                className="focus:ring-2 focus:ring-offset-1 focus:ring-primary-500"
              />
            </FormControl>
            <FormDescription>
              Include the book, chapter and verse(s)
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <DatePickerField 
        form={form} 
        date={date} 
        setDate={setDate} 
      />
    </>
  );
}
